// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".animate .completed[data-v-a5cd190c]{animation:DialProgress-a5cd190c .5s cubic-bezier(.77,0,.175,1) forwards}@keyframes DialProgress-a5cd190c{0%{stroke-dasharray:var(--last-position)}to{stroke-dasharray:var(--new-position)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
